import * as React from 'react'

import * as Sentry from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'

import { YesPosthogProvider } from './lib/posthog'
import { queryClient } from './lib/tanstack-query'
import { createRouter } from './lib/tanstack-router'

const router = createRouter()

Sentry.init({
  enabled: process.env.NODE_ENV === 'production',
  environment: process.env.NODE_ENV,
  dsn: 'https://a51e06c25f47f895bdfafc8f58c3e96e@o4507258493534208.ingest.us.sentry.io/4509785250332672',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
    Sentry.tanstackRouterBrowserTracingIntegration(router),
    Sentry.feedbackIntegration({
      colorScheme: 'light',
      showBranding: false,
    }),
  ],
  sendDefaultPii: true,
  tracesSampleRate: 0.5,
})

function AppEntry() {
  return (
    <YesPosthogProvider>
      <React.Suspense fallback={null}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} context={{ qc: queryClient }} />
        </QueryClientProvider>
      </React.Suspense>
    </YesPosthogProvider>
  )
}

export { AppEntry }
